import React, { Fragment, Component } from 'react'
import Select from 'react-select'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect,useParams } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import CreateBloc from './Blocs/CreateBloc'
import UpdateBloc from './Blocs/UpdateBloc'
import DetailBloc from './Blocs/DetailBloc'
import CustomSelect from'../../../../helpers/ui/CustomSelect'
import moment from "moment"

var reformatEmployee = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.employee_nip+" - "+region.employee_name;
      newObj["value"] = region.employee_uuid;
      newObj["model"] = region;
      return newObj;
    });
};

var reformatPosition = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.position_name;
      newObj["value"] = region.position_uuid;
      newObj["model"] = region;
      return newObj;
    });
};

var reformatOptions = function(raw, label, value) {
    return raw.map(function(data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];
  
      return newObj;
    });
};

class IndexView extends Component {

    createBloc = new CreateBloc();
    updateBloc = new UpdateBloc();
    detailBloc = new DetailBloc();

    constructor(props) {
        super(props)
        this.state = {
            optionTipe : [
                { label: "Manajerial", value: "1" },
                { label: "Teknis", value: "2" },
                { label: "Sosio Kultural", value: "3" }
            ],
            optionLevel: [
                { value: 'chocolate', label: 'Chocolate' },
                { value: 'strawberry', label: 'Strawberry' },
                { value: 'vanilla', label: 'Vanilla' }
              ],
            optionCategories: [],
            dataForm: {},
            levelComps: [
                {
                    name: "",
                    level : 1
                },
            ],
            EmpComps: [
                {
                    euuid: "",
                    idx : 1
                },
            ],
            jenisdokumen : [
                {value:'1',label:'Dokumen Pelantikan'},
                {value:'2',label:'Pakta Integritas'},
                {value:'3',label:'Dokumen SPP, SPMJ, SPMT'},
            ],
            selectStates : [],
            selectStatesPosition : [],
            selectPelantik : null,
            selectRohaniawan : null,
            selectSaksi1 : null,
            selectSaksi2 : null,
            selectDoctype : null,
            dochead:{},
            pegawai_pelantikan: [{}],
            pelantik: [],
            rohaniawan: [],
            saksi1: [],
            saksi2: [],
            detail: [],
        }
    }

    addLevel = () => {
        let count = this.state.levelComps.length;
        this.setState({
            levelComps: [
                ...this.state.levelComps,
                {
                    name : "",
                    level : count == 0 ? (count+1) : this.state.levelComps.slice(-1)[0].level + 1
                }
            ]
        })

        console.log(this.state.levelComps)
    }
    addEmp = () => {
        let count = this.state.EmpComps.length;
        this.setState({
            EmpComps: [
                ...this.state.EmpComps,
                {
                    euuid : "",
                    idx : count == 0 ? (count+1) : this.state.EmpComps.slice(-1)[0].idx + 1
                }
            ]
        })

        console.log(this.state.EmpComps)
    }

    delLevel = (data) => {
        let count = this.state.levelComps.length-1;
        this.setState({
            levelComps: [
                ...this.state.levelComps.filter((val) => val!=data)
                
                // (count-1)
            ]
        })
    }
    delEmp = (data) => {
        let count = this.state.EmpComps.length-1;
        this.setState({
            EmpComps: [
                ...this.state.EmpComps.filter((val) => val!=data)
                
                // (count-1)
            ]
        })
    }

    reformatLevel = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["name"] = data.level_name;
          newObj["level"] = data.level_no;
      
          return newObj;
        });
    }
    reformatEmp = (raw) => {
        return raw.map(function(data,i) {
          var newObj = {};
          newObj["euuid"] = data.employee_uuid;
          newObj["idx"] = i;
      
          return newObj;
        });
    }

    handleSelectChange = (selectedOption, index) => {
        const newSelectStates = [...this.state.selectStates];
        newSelectStates[index] = selectedOption;
        this.setState({ selectStates: newSelectStates });
      };
      handleSelectChangePosition = (selectedOption, index) => {
        const newSelectStatesPosition = [...this.state.selectStatesPosition];
        newSelectStatesPosition[index] = selectedOption;
        this.setState({ selectStatesPosition: newSelectStatesPosition });
      };
    handleSelectChangepelantik = (selectedOption) => {
        this.setState({ selectpelantik: selectedOption.value });
      };
    
    handleRemoveSelect = (index) => {
        const newSelectStates = this.state.selectStates.filter((_, i) => i !== index);
        this.setState({ selectStates: newSelectStates });
        
    };

    submitData = async () => {
        await this.updateBloc.fetchUpdate(this.state.dataForm)
    }

    handleChangeInputLevel = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.levelComps];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.name = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({levelComps : items});
    }
    handleChangeInputEmp = (e, index) => {
        console.log(e);
        // 1. Make a shallow copy of the items
        let items = [...this.state.EmpComps];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.euuid = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({EmpComps : items});
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        console.log(values)
        // return 

        this.setState({
            dataForm: values,
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const uuid = urlParams.get('uuid');
            this.detailBloc.detailChannel.subscribe((result) => {
                switch (result.status) {
                    case apiResponse.COMPLETED:
                        if(result.data.status) {
                            let response = result.data.response
                            // console.log(response.dochead)
                            // console.log('ini response')
                            this.setState({
                                detail: response,
                                dochead: response.dochead,
                                // dataForm: response.dochead,
                                pegawai_pelantikan: response.pegawai_pelantikan,
                                pelantik: response.pelantik,
                                rohaniawan: response.rohaniawan,
                                saksi1: response.saksi[0],
                                saksi2: response.saksi[1],
                                EmpComps: this.reformatEmp(response.pegawai_pelantikan),
                                selectSaksi1 : response.saksi[0].employee_uuid,
                                selectSaksi2 : response.saksi[1].employee_uuid,
                            })
                            console.log(this.state.pegawai_pelantikan[0].inaguration_document_participant_position_uuid)
                            console.log('ini state pegawai ')
                        }
                        break
                    case apiResponse.ERROR:
                        
                        break
                    default:
                        break
                }
            })
            this.detailBloc.fetchDetail({uuid: uuid })

        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.createBloc.listPegawaiChanel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            employeeItems: reformatEmployee(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.createBloc.fetchPegawai()

        this.createBloc.listJabatanChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    console.log(result.data.response.result)
                    console.log('ini position')
                    this.setState({ 
                        positionOption: result.data.response.result, loadingPosition: false,
                        positionItems: reformatPosition(result.data.response.result) 
                    })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })
        this.createBloc.fetchListJabatan()
        // get data type
        // this.createBloc.accategoriesChannel.subscribe((result) => {
        //     switch (result.status) {
        //         case apiResponse.COMPLETED:
        //             if(result.data.status) {
        //                 let response = result.data.response
        //                 //console.log(response)
                        
        //                 this.setState({
        //                     optionCategories: reformatOptions(
        //                         response.result, 
        //                         'category_name',
        //                         'category_id'
        //                     )
        //                 })
        //             }
        //             break
        //         case apiResponse.ERROR:
                    
        //             break
        //         default:
        //             break
        //     }
        // })
        // this.createBloc.fetchCategories({})
        console.log(this.state.dochead);
        console.log('ini dataform state');
    }
    componentWillUnmount() {
        this.detailBloc.detailChannel.unsubscribe()
        this.createBloc.listPegawaiChanel.unsubscribe()
        this.createBloc.listJabatanChannel.unsubscribe()
    }
    
    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>Form Tambah Data Dokumen Pelantikan ,Pakta integritas ,SPP ,SPMJ & SPMT</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Form Inputan digunakan untuk melakukan generate 5 dokumen
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Pilih Jenis Dokumen <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <Select
                                                    required="required"
                                                    options={this.state.jenisdokumen}
                                                    onChange={selectedOption => this.setState({ selectDoctype: selectedOption.value })}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Jenis dokumen"
                                                />
                                                <AvField
                                                    type="hidden"
                                                    value={this.state.selectDoctype}
                                                    onChange={() => {}}
                                                    name="tipedokumen"
                                                />
                                            </Col>
                                        </Row> */}
                                        <AvField
                                            type="hidden"
                                            value={this.state.dochead.inaguration_document_uuid}
                                            onChange={() => {}}
                                            placeholder="Pilih Pegawai"
                                            name="inaguration_document_uuid"
                                        />
                                                
                                            
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Pelantikan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="tanggal_pelantikan"
                                                    placeholder="Tanggal Pelantikan..."
                                                    type="date"
                                                    className="form-control"
                                                    id="tanggal_pelantikan"
                                                    required="required"
                                                    value={this.state.dochead.inaguration_document_date}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                           Lokasi Pelantikan
                                            </label>
                                            <Col md="5">
                                                  <AvField
                                                    name="lokasi"
                                                    placeholder="Lokasi Pelantikan.."
                                                    type="text"
                                                    className="form-control"
                                                    id="lokasi"
                                                    value={this.state.dochead.inaguration_document_place}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                           Tempat Pelantikan
                                            </label>
                                            <Col md="5">
                                                  <AvField
                                                    name="tempat"
                                                    placeholder="Tempat Pelantikan (Nama tempat/Gedung pelantikan).."
                                                    type="text"
                                                    className="form-control"
                                                    id="tempat"
                                                    value={this.state.dochead.inaguration_document_place_room}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label htmlFor="fieldGender" className="col-md-3 col-form-label">Pilih Pegawai<span className="text-danger">*</span></Label>
                                            <Col md="6">

                                                {
                                                    this.state.EmpComps.map((data, index) => {
                                                        return (
                                                            <div className="row">
                                                                <div className="col-md-5">
                                                                {/* <AvField
                                                                    name={`level[${index}]`}
                                                                    placeholder={`Level-${(index+1)}`}
                                                                    type="text"
                                                                    errorMessage="Masukkan Level"
                                                                    className="form-control mb-2"
                                                                    validate={{ required: { value: true } }}
                                                                    onChange={(e) => {
                                                                        this.handleChangeInputLevel(e, index)
                                                                    }}
                                                                    value={data.name}
                                                                /> */}
                                                                <CustomSelect
                                                                    name={`slcemployeuuid[${index}]`}
                                                                    // value={this.state.employeeItems.filter(option => 
                                                                    //   option.value === this.state.employeeSelected)}
                                                                    // value={this.state.selectStates[index] || null}
                                                                    onChange={(e) => {
                                                                        this.handleSelectChange(e, index)
                                                                    }}
                                                                    validate={{ required: { value: true } }}
                                                                    options={this.state.employeeItems}
                                                                    classNamePrefix=""
                                                                    placeholder={`Pilih Pegawai-${index+1}`}
                                                                    key={index}
                                                                    defaultValue={data.euuid}
                                                                />
                                                                <AvField
                                                                    type="hidden"
                                                                    value={this.state.selectStates[index] ? this.state.selectStates[index].value : ''}
                                                                    onChange={() => {}}
                                                                    placeholder={`Hasil Opsi ${index + 1}`}
                                                                    name={`employeuuid[${index}]`}
                                                                />
                                                                </div>
                                                                <div className="col-md-5">
                                                                
                                                                    <CustomSelect
                                                                        name={`slcposition[${index}]`}
                                                                        // value={this.state.employeeItems.filter(option => 
                                                                        //   option.value === this.state.employeeSelected)}
                                                                        value={this.state.selectStatesPosition[index] || null}
                                                                        onChange={(e) => {
                                                                            this.handleSelectChangePosition(e, index)
                                                                        }}
                                                                        validate={{ required: { value: true } }}
                                                                        options={this.state.positionItems}
                                                                        classNamePrefix=""
                                                                        placeholder={`Pilih Jabatan-${index+1}`}
                                                                        defaultValue={this.state.pegawai_pelantikan[index]?.inaguration_document_participant_position_uuid}
                                                                    />
                                                                    <AvField
                                                                        type="hidden"
                                                                        value={this.state.selectStatesPosition[index] ? this.state.selectStatesPosition[index].value : ''}
                                                                        onChange={() => {}}
                                                                        placeholder={`Hasil Opsi ${index + 1}`}
                                                                        name={`positionname[${index}]`}
                                                                    />
                                                                </div>
                                                                <div className="col-md-2 text-right">
                                                                    {
                                                                        index == 0 ? 
                                                                        <div className="col-md-2 text-right">
                                                                            <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                                                                color="success" 
                                                                                type="button"
                                                                                onClick={this.addEmp}
                                                                                ><i className="uil-plus-circle"></i>
                                                                            </Button>
                                                                        </div> :
                                                                            <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                                                                color="danger" 
                                                                                type="button"
                                                                                onClick={() => {
                                                                                    this.delEmp(data)
                                                                                    this.handleRemoveSelect(index)
                                                                                }}
                                                                                ><i className="uil-trash-alt"></i>
                                                                            </Button>
                                                                    }
                                                                    
                                                                </div>
                                                            </div>
                                                        )    
                                                    })
                                                }

                                                
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Pejabat Pelantik<span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                
                                                <CustomSelect
                                                    name="slcpelantikuuid"
                                                    onChange={selectedOption => this.setState({ selectPelantik: selectedOption.value })}
                                                    validate={{ required: { value: true } }}
                                                    options={this.state.employeeItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Pejabat pelantik..."
                                                    defaultValue={this.state.pelantik.employee_uuid}
                                                />
                                                <AvField
                                                    type="hidden"
                                                    value={this.state.selectPelantik}
                                                    onChange={() => {}}
                                                    placeholder="Pilih Pegawai"
                                                    name="pelantikuuid"
                                                />
                                                
                                            </Col>
                                        </Row>
                                        <hr />
                                        <Row className="mb-3">
                                                    <label
                                                        htmlFor=""
                                                        className="col-md-3 col-form-label"
                                                    >
                                                Field Dokumen Dokumen Pelantikan
                                                    </label>
                                                    <Col md="5">
                                                        
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Pejabat Pendamping (Rohaniawan Islam)
                                            </label>
                                            <Col md="8">
                                                
                                            {/* <Select
                                                    name="slcrohaniawan"
                                                    onChange={selectedOption => this.setState({ selectRohaniawan: selectedOption.value })}
                                                    validate={{ required: { value: true } }}
                                                    options={this.state.employeeItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Pejabat pendamping (rohaniawan)..."
                                                /> */}
                                                <div className='row'>
                                                    <div className='col-md-5'>
                                                        <AvField
                                                            type="text"
                                                            onChange={() => {}}
                                                            placeholder="Pejabat Pendamping (Rohaniawan)"
                                                            name="rohaniawan"
                                                            value={this.state.dochead.inaguration_document_rohaniawan}
                                                        />
                                                    </div>
                                                    <div className='col-md-5'>
                                                        <AvField
                                                            type="text"
                                                            onChange={() => {}}
                                                            placeholder="Jabatan"
                                                            name="islam_jabatan"
                                                            value={this.state.dochead.inaguration_document_rohaniawan_position}
                                                        />
                                                    </div>
                                                    <div className='col-md-2'>
                                                        <AvField
                                                            type="text"
                                                            onChange={() => {}}
                                                            placeholder="NIP"
                                                            name="islam_nip"
                                                            value={this.state.dochead.inaguration_document_rohaniawan_islam_nip}
                                                        />
                                                    </div>
                                                </div>
                                                
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Pejabat Pendamping (Rohaniawan Kristen)
                                            </label>
                                            <Col md="8">
                                                
                                            {/* <Select
                                                    name="slcrohaniawan"
                                                    onChange={selectedOption => this.setState({ selectRohaniawan: selectedOption.value })}
                                                    validate={{ required: { value: true } }}
                                                    options={this.state.employeeItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Pejabat pendamping (rohaniawan)..."
                                                /> */}
                                                <div className='row'>
                                                    <div className='col-md-5'>
                                                        <AvField
                                                            type="text"
                                                            onChange={() => {}}
                                                            placeholder="Pejabat Pendamping (Rohaniawan)"
                                                            name="kristen"
                                                            value={this.state.dochead.inaguration_document_rohaniawan_kristen}
                                                        />
                                                    </div>
                                                    <div className='col-md-5'>
                                                        <AvField
                                                            type="text"
                                                            onChange={() => {}}
                                                            placeholder="Jabatan"
                                                            name="kristen_jabatan"
                                                            value={this.state.dochead.inaguration_document_rohaniawan_kristen_position}
                                                        />
                                                    </div>
                                                    <div className='col-md-2'>
                                                        <AvField
                                                            type="text"
                                                            onChange={() => {}}
                                                            placeholder="NIP"
                                                            name="kristen_nip"
                                                            value={this.state.dochead.inaguration_document_rohaniawan_kristen_nip}
                                                        />
                                                    </div>
                                                </div>
                                                
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Pejabat Pendamping (Rohaniawan Katholik)
                                            </label>
                                            <Col md="8">
                                                
                                            {/* <Select
                                                    name="slcrohaniawan"
                                                    onChange={selectedOption => this.setState({ selectRohaniawan: selectedOption.value })}
                                                    validate={{ required: { value: true } }}
                                                    options={this.state.employeeItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Pejabat pendamping (rohaniawan)..."
                                                /> */}
                                                <div className='row'>
                                                    <div className='col-md-5'>
                                                        <AvField
                                                            type="text"
                                                            onChange={() => {}}
                                                            placeholder="Pejabat Pendamping (Rohaniawan)"
                                                            name="katholik"
                                                            value={this.state.dochead.inaguration_document_rohaniawan_katholik}
                                                        />
                                                    </div>
                                                    <div className='col-md-5'>
                                                        <AvField
                                                            type="text"
                                                            onChange={() => {}}
                                                            placeholder="Jabatan"
                                                            name="katholik_jabatan"
                                                            value={this.state.dochead.inaguration_document_rohaniawan_katholik_position}
                                                        />
                                                    </div>
                                                    <div className='col-md-2'>
                                                        <AvField
                                                            type="text"
                                                            onChange={() => {}}
                                                            placeholder="NIP"
                                                            name="katholik_nip"
                                                            value={this.state.dochead.inaguration_document_rohaniawan_katholik_nip}
                                                        />
                                                    </div>
                                                </div>
                                                
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Pejabat Pendamping (Rohaniawan Hindu)
                                            </label>
                                            <Col md="8">
                                                
                                            {/* <Select
                                                    name="slcrohaniawan"
                                                    onChange={selectedOption => this.setState({ selectRohaniawan: selectedOption.value })}
                                                    validate={{ required: { value: true } }}
                                                    options={this.state.employeeItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Pejabat pendamping (rohaniawan)..."
                                                /> */}
                                                <div className='row'>
                                                    <div className='col-md-5'>
                                                        <AvField
                                                            type="text"
                                                            onChange={() => {}}
                                                            placeholder="Pejabat Pendamping (Rohaniawan)"
                                                            name="hindu"
                                                            value={this.state.dochead.inaguration_document_rohaniawan_hindu}
                                                        />
                                                    </div>
                                                    <div className='col-md-5'>
                                                        <AvField
                                                            type="text"
                                                            onChange={() => {}}
                                                            placeholder="Jabatan"
                                                            name="hindu_jabatan"
                                                            value={this.state.dochead.inaguration_document_rohaniawan_hindu_position}
                                                        />
                                                    </div>
                                                    <div className='col-md-2'>
                                                        <AvField
                                                            type="text"
                                                            onChange={() => {}}
                                                            placeholder="NIP"
                                                            name="hindu_nip"
                                                            value={this.state.dochead.inaguration_document_rohaniawan_hindu_nip}
                                                        />
                                                    </div>
                                                </div>
                                                
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Pejabat Pendamping (Rohaniawan Budha)
                                            </label>
                                            <Col md="8">
                                                
                                            {/* <Select
                                                    name="slcrohaniawan"
                                                    onChange={selectedOption => this.setState({ selectRohaniawan: selectedOption.value })}
                                                    validate={{ required: { value: true } }}
                                                    options={this.state.employeeItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Pejabat pendamping (rohaniawan)..."
                                                /> */}
                                                <div className='row'>
                                                    <div className='col-md-5'>
                                                        <AvField
                                                            type="text"
                                                            onChange={() => {}}
                                                            placeholder="Pejabat Pendamping (Rohaniawan)"
                                                            name="budha"
                                                            value={this.state.dochead.inaguration_document_rohaniawan_budha}
                                                        />
                                                    </div>
                                                    <div className='col-md-5'>
                                                        <AvField
                                                            type="text"
                                                            onChange={() => {}}
                                                            placeholder="Jabatan"
                                                            name="budha_jabatan"
                                                            value={this.state.dochead.inaguration_document_rohaniawan_budha_position}
                                                        />
                                                    </div>
                                                    <div className='col-md-2'>
                                                        <AvField
                                                            type="text"
                                                            onChange={() => {}}
                                                            placeholder="NIP"
                                                            name="budha_nip"
                                                            value={this.state.dochead.inaguration_document_rohaniawan_budha_nip}
                                                        />
                                                    </div>
                                                </div>
                                                
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Pejabat Pendamping (Rohaniawan Konghucu)
                                            </label>
                                            <Col md="8">
                                                
                                            {/* <Select
                                                    name="slcrohaniawan"
                                                    onChange={selectedOption => this.setState({ selectRohaniawan: selectedOption.value })}
                                                    validate={{ required: { value: true } }}
                                                    options={this.state.employeeItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Pejabat pendamping (rohaniawan)..."
                                                /> */}
                                                <div className='row'>
                                                    <div className='col-md-5'>
                                                        <AvField
                                                            type="text"
                                                            onChange={() => {}}
                                                            placeholder="Pejabat Pendamping (Rohaniawan)"
                                                            name="konghucu"
                                                            value={this.state.dochead.inaguration_document_rohaniawan_konghucu}
                                                        />
                                                    </div>
                                                    <div className='col-md-5'>
                                                        <AvField
                                                            type="text"
                                                            onChange={() => {}}
                                                            placeholder="Jabatan"
                                                            name="konghucu_jabatan"
                                                            value={this.state.dochead.inaguration_document_rohaniawan_konghucu_position}
                                                        />
                                                    </div>
                                                    <div className='col-md-2'>
                                                        <AvField
                                                            type="text"
                                                            onChange={() => {}}
                                                            placeholder="NIP"
                                                            name="konghucu_nip"
                                                            value={this.state.dochead.inaguration_document_rohaniawan_konghucu_nip}
                                                        />
                                                    </div>
                                                </div>
                                                
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Saksi-1<span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                
                                            <CustomSelect
                                                    name="slcsaksi1"
                                                    onChange={selectedOption => this.setState({ selectSaksi1: selectedOption.value })}
                                                    validate={{ required: { value: true } }}
                                                    options={this.state.employeeItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih saksi-1..."
                                                    defaultValue={this.state.saksi1.employee_uuid}
                                                    
                                                    />
                                                <AvField
                                                    type="hidden"
                                                    value={this.state.selectSaksi1}
                                                    onChange={() => {}}
                                                    placeholder="Pilih Pegawai"
                                                    name="saksi1uuid"
                                                    />
                                                
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                    >
                                                Saksi-2<span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    
                                                <CustomSelect
                                                        name="slcsaksi2"
                                                        onChange={selectedOption => this.setState({ selectSaksi2: selectedOption.value })}
                                                        validate={{ required: { value: true } }}
                                                        options={this.state.employeeItems}
                                                        classNamePrefix=""
                                                        placeholder="Pilih Saksi-2..."
                                                        defaultValue={this.state.saksi2.employee_uuid}
                                                        />
                                                    <AvField
                                                        type="hidden"
                                                        value={this.state.selectSaksi2}
                                                        onChange={() => {}}
                                                        placeholder="Pilih Pegawai"
                                                        name="saksi2uuid"
                                                    />
                                                    
                                                </Col>
                                            </Row>
                                            <hr/>
                                        <Row className="mb-3">
                                                    <label
                                                        htmlFor=""
                                                        className="col-md-3 col-form-label"
                                                    >
                                                Field Dokumen SPP , SPMJ, SPMT
                                                    </label>
                                                    <Col md="5">
                                                        
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor=""
                                                        className="col-md-3 col-form-label"
                                                    >
                                                No SK <span className="text-danger">*</span>
                                                    </label>
                                                    <Col md="5">
                                                        <AvField
                                                            name="sk_no"
                                                            placeholder="No SK.."
                                                            type="text"
                                                            className="form-control"
                                                            id="sk_no"
                                                            validate={{ required: { value: true } }}
                                                            value={this.state.dochead.inaguration_document_sk_number}
                                                            />
                                                    </Col>
                                                </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="tanggal_sk"
                                                    placeholder="Tanggal sk..."
                                                    type="date"
                                                    className="form-control"
                                                    id="tanggal_sk"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dochead.inaguration_document_sk_date}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                                    <label
                                                        htmlFor=""
                                                        className="col-md-3 col-form-label"
                                                    >
                                                No SPP <span className="text-danger">*</span>
                                                    </label>
                                                    <Col md="5">
                                                        <AvField
                                                            name="sppno"
                                                            placeholder="No SPP.."
                                                            type="text"
                                                            className="form-control"
                                                            id="sppno"
                                                            value={this.state.dochead.inaguration_document_sppno}
                                                            validate={{ required: { value: true } }}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor=""
                                                        className="col-md-3 col-form-label"
                                                    >
                                                No SPMJ <span className="text-danger">*</span>
                                                    </label>
                                                    <Col md="5">
                                                        <AvField
                                                            name="spmjno"
                                                            placeholder="No SPMJ.."
                                                            type="text"
                                                            className="form-control"
                                                            id="spmjno"
                                                            value={this.state.dochead.inaguration_document_spmjno}
                                                            validate={{ required: { value: true } }}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor=""
                                                        className="col-md-3 col-form-label"
                                                    >
                                                No SPMT <span className="text-danger">*</span>
                                                    </label>
                                                    <Col md="5">
                                                        <AvField
                                                            name="spmtno"
                                                            placeholder="No SPMT.."
                                                            type="text"
                                                            className="form-control"
                                                            id="spmtno"
                                                            value={this.state.dochead.inaguration_document_spmtno}
                                                            validate={{ required: { value: true } }}
                                                        />
                                                    </Col>
                                                </Row>
                                            <hr />
                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/dokumen_pelantikan.html">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/dokumen_pelantikan.html'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView